









































import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {initialHub, IHub, isInitialHub} from "@/models/StoreModels";
import Dialog from "@/views/Dialog/Dialog.vue";
import Maps from '@/views/components/Maps/Maps.vue';


const hubs = namespace("hubs");


@Component({
  name: 'HubSelector',
  components: {
    Dialog,
    Maps,
  },
})
export default class HubSelector extends Vue {
  @hubs.Getter('getHubList')
  private hubList!: IHub[];

  @Prop({ default: () => initialHub() })
  private hub!: IHub;

  private get isInitialHub() {
    return isInitialHub(this.hub);
  }

  private dialogVisible: boolean = false;

  private showDialog() {
    this.dialogVisible = true;
  }

  private closeDialog() {
    this.dialogVisible = false;
  }

  private selectHub(hub: IHub) {
    this.closeDialog();
    this.$emit('selected:hub', hub);
  }
}
